import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DepartmentTeamsListPage } from '@/pages/department/teams/DepartmentTeamsListPage';
import { dataTableSearchSchema } from '@/lib/validation/dataTableSearchSchema';

export const Route = createFileRoute('/$slug/department/teams/')({
  component: DepartmentTeamsListPage,
  validateSearch: dataTableSearchSchema({
    dept: z.string().optional()
  })
});
